module.exports = "<a class=\"navigation-link\" ng-href=\"{{url}}\" ui-sref-active=\"is-active\">\r\n    <span>\r\n        My Favourite Recipes\r\n        <span ng-if=\"!recipeListsService.loadingCount\">({{count}})</span>\r\n        <wow-loading-spinner class=\"searchCountSpinner\" ng-if=\"recipeListsService.loadingCount\"></wow-loading-spinner>\r\n    </span>\r\n</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/recipe/recipe-savedList/recipe-savedList-navigation.directive.html
// module id = 125
// module chunks = 0 1